import React from 'react';
import ChipComponent from '../../../../atoms/chipComponent';
import useStyles from '../styles';

const Chat = () => {
  const classes = useStyles();

  const tags = ['HDFC', 'Footwear', 'Healthcare', 'Skincare'];
  return (
    <>
      <div className={classes.chatContainer}>
        <div className={classes.chatMain}>
          <div>
            <div className={classes.headingText}>Help me create</div>
            <div className={classes.flexRow}>
              <ChipComponent label="Summary" onClick={() => {}} className={classes.chipLabel} />
              <ChipComponent label="Tags" onClick={() => {}} className={classes.chipLabel} />
            </div>
          </div>
          <div>
            <div className={classes.headingText}>Tags</div>
            <div className={classes.flexRow}>
              {tags &&
                tags.length > 0 &&
                tags.map((x, i) => {
                  return (
                    <ChipComponent
                      key={i}
                      label={x}
                      onClick={() => {}}
                      className={`${classes.chipLabel} ${classes.ovverrideChipLbl}`}
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
